var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"rounded":"sm","show":!_vm.data}},[_c('b-card',{attrs:{"title":"Status overzicht"}},[(_vm.data)?_c('app-echart-bar',{attrs:{"option-data":_vm.data}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }